var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error form__results form__results_block_error"},[_c('div',{staticClass:"error__wrapper"},[_c('p',{staticClass:"error__text"},[_vm._v("\n      "+_vm._s(_vm.label ? _vm.label : 'Something went wrong... Please try again later')+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }